export class B64Error extends Error {
  public constructor(message: string) {
    super(message);
    this.name = "B64Error";
  }
}

export function bytesToB64(bytes: Uint8Array): string {
  let binary = "";
  const chunk = 8192;
  for (let i = 0; i < bytes.length; i += chunk) {
    const slice = bytes.slice(i, i + chunk);
    let part = "";
    for (let j = 0; j < slice.length; j += 1) {
      const byte: number | undefined = slice[j];
      if (byte === undefined) {
        throw new B64Error("Unreachable byte index.");
      }
      part += String.fromCharCode(byte);
    }
    binary += part;
  }
  return btoa(binary);
}

export function b64ToBytes(input: string): Uint8Array {
  let binary: string;
  try {
    binary = atob(input);
  } catch {
    throw new B64Error("Invalid base64 input.");
  }
  const out = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    out[i] = binary.charCodeAt(i) & 0xff;
  }
  return out;
}

const TEXT_ENCODER = new TextEncoder();
const TEXT_DECODER = new TextDecoder();

export function utf8ToB64(input: string): string {
  return bytesToB64(TEXT_ENCODER.encode(input));
}

export function b64ToUtf8(input: string): string {
  return TEXT_DECODER.decode(b64ToBytes(input));
}
